import { render, staticRenderFns } from "./ForgotPasswordView.vue?vue&type=template&id=b6eec6e4&"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports